import React from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

export const useStyles = makeStyles((theme) => ({
    tableTitle: {
        display: 'inline-block',
        position: 'relative',
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        fontSize: '1rem',
        fontWeight: 600,
    },
    table: {
        marginBottom: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0,
        },
    },
}));

const WidgetTemplate = ({ title, children }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <>
            <Typography className={classes.tableTitle} variant="h6">
                {title}
            </Typography>
            <TableContainer className={classes.table} component={Paper}>
                <Table size="small" aria-label="user permissions table">
                    <TableBody>
                        <TableRow>
                            <TableCell>{children}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default WidgetTemplate;